export default __webpack_public_path__ + "static/media/logo-2.e0241105.png";